import React, { useEffect, useRef, useState } from 'react';
import ads from '../../styles/components/ads.module.scss';

interface HorizontalAdProps {
    adSlot: string;
    height?: number;
}

export default function HorizontalAd({
                                         adSlot,
                                         height = 90
                                     }: HorizontalAdProps) {
    const wrapperCls = useRef('ad-wrap-hz-' + Math.random().toString(36).substr(2, 8));
    const [blocked, setBlocked] = useState(false);
    const AD_CLIENT = 'ca-pub-6425578398196260';

    useEffect(() => {
        try {
            // @ts-ignore
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            setTimeout(() => {
                const ins = document.querySelector(`.${wrapperCls.current} ins.adsbygoogle`);
                if (!ins || (ins as HTMLElement).offsetHeight === 0) {
                    setBlocked(true);
                }
            }, 500);
        } catch {
            setBlocked(true);
        }
    }, []);

    return (
        <div
            className={`${wrapperCls.current} d-block d-xl-none ${ads.horizontalAd}`}
            style={{ width: '100%', height }}
        >
            {blocked ? (
                <div style={{
                    width: '100%', height,
                    background: '#eee', color: '#555',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, textAlign: 'center'
                }}>
                    Please disable adblock to support us
                </div>
            ) : (
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block', width: '100%', height }}
                    data-ad-client={AD_CLIENT}
                    data-ad-slot={adSlot}
                    data-ad-format="auto"
                ></ins>
            )}
        </div>
    );
}
